import { render } from "./ImageElements.vue?vue&type=template&id=45d38aee&scoped=true"
import script from "./ImageElements.vue?vue&type=script&lang=js"
export * from "./ImageElements.vue?vue&type=script&lang=js"

import "./ImageElements.vue?vue&type=style&index=0&id=45d38aee&scoped=true&lang=css"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45d38aee"]])

export default __exports__